var lib_core = require("./index.js");
var UserController = require("./userController.js");

var AppWithoutDocumentController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
    this.dataManagerConfig = null;
};
lib_core.inherit(AppWithoutDocumentController, lib_core.Controller);
AppWithoutDocumentController.inject = {
    userController : UserController
};


AppWithoutDocumentController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    this.dataManagerConfig = this.configuration.dataManagerConfig;
    var dataManager = lib_core.DataManagerClientFactory.getInstance(this.dataManagerConfig.content_server_client, this.userController);
    this.root.dataLoader = {dataManager: dataManager};
    this.root.dataManager = dataManager; //TODO uniformise
};

module.exports = AppWithoutDocumentController;
